import { useLingui } from '@lingui/react/macro';
import { withForm } from '@worldcoo/ui/components/form';
import { detailsFormOpts } from './details-form.opts';

export const DonorFields = withForm({
	...detailsFormOpts,
	render: function DonorFields({ form }) {
		const { t } = useLingui();

		return (
			<div className="flex flex-col gap-3">
				<div className="flex flex-col gap-3 sm:flex-row">
					<form.AppField
						name="firstname"
						children={(field) => (
							<field.TextField
								label={t`Name`}
								variant="outline"
								className="w-full"
								autoComplete="given-name"
								autoCapitalize="words"
							/>
						)}
					/>
					<form.AppField
						name="lastname"
						children={(field) => (
							<field.TextField
								label={t`Last Name`}
								variant="outline"
								className="w-full"
								autoComplete="family-name"
								autoCapitalize="words"
							/>
						)}
					/>
				</div>
				<form.AppField
					name="email"
					children={(field) => (
						<field.TextField
							label={t`Email`}
							variant="outline"
							autoComplete="email"
							inputMode="email"
							autoCapitalize="off"
							autoCorrect="off"
							spellCheck={false}
						/>
					)}
				/>
				<form.AppField
					name="repeatEmail"
					children={(field) => (
						<field.TextField
							label={t`Repeat your email`}
							variant="outline"
							autoComplete="email"
							inputMode="email"
							autoCapitalize="off"
							autoCorrect="off"
							spellCheck={false}
						/>
					)}
				/>
			</div>
		);
	},
});
